module.exports = __webpack_public_path__ + "img/carousel-hsp2-2.1417b8da.png";